<template>
  <footer class="sal-bottom-bar">
    <div class="sal-bottom-inner">
      <button
        v-if="showBack"
        type="button"
        class="sal-btn-back"
        :disabled="loading"
        @click="$emit('back')"
      >
        <i class="bi bi-arrow-left sal-btn-icon" aria-hidden="true"></i>
        <span class="sal-btn-text">Atrás</span>
      </button>

      <button
        type="button"
        class="sal-btn-primary"
        :disabled="loading"
        @click="$emit('next')"
      >
        <span v-if="loading" class="sal-btn-content">
          <i class="bi bi-arrow-repeat sal-btn-icon sal-btn-spin" aria-hidden="true"></i>
          <span class="sal-btn-text">{{ loadingLabel }}</span>
        </span>

        <span v-else class="sal-btn-content">
          <i class="bi sal-btn-icon" :class="nextIcon" aria-hidden="true"></i>
          <span class="sal-btn-text">{{ nextLabel }}</span>
        </span>
      </button>
    </div>
  </footer>
</template>

<script setup>
defineProps({
  showBack: {
    type: Boolean,
    default: false
  },
  nextLabel: {
    type: String,
    default: 'Siguiente'
  },
  nextIcon: {
    type: String,
    default: 'bi-arrow-right'
  },
  loading: {
    type: Boolean,
    default: false
  },
  loadingLabel: {
    type: String,
    default: 'Enviando...'
  }
})

defineEmits(['back', 'next'])
</script>
